"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailboxWebSocketChannel = exports.useMailboxWebSocketChannel = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const webSocket_1 = require("../../../webSocket");
const WebSocketContext_1 = require("../../../webSocket/WebSocketContext");
const mailboxActions_1 = require("../../store/mailboxActions");
const useMailboxWebSocketChannel = () => {
    const dispatch = react_redux_1.useDispatch();
    const webSocketConnection = WebSocketContext_1.useWebSocketConnection();
    const messageHandler = react_1.useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (message) => {
        var _a, _b;
        switch (message.type) {
            case 'unread_counts': {
                if (!message.data)
                    return;
                dispatch(mailboxActions_1.setUnreadCounts({
                    unreadConversationsCount: (_a = message.data.unread_conversations) !== null && _a !== void 0 ? _a : 0,
                    unreadMessagesCount: (_b = message.data.unread_messages) !== null && _b !== void 0 ? _b : 0,
                }));
                break;
            }
        }
    }, [dispatch]);
    webSocket_1.useWebSocketChannel('MailboxChannel', webSocketConnection
        ? { extension_gid: webSocketConnection.currentProfileGid }
        : undefined, messageHandler);
};
exports.useMailboxWebSocketChannel = useMailboxWebSocketChannel;
const MailboxWebSocketChannel = () => {
    exports.useMailboxWebSocketChannel();
    return null;
};
exports.MailboxWebSocketChannel = MailboxWebSocketChannel;
